import { Platform, StyleSheet } from "react-native";
import FontFamily from "../../../../constants/fonts";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  toggleContainer: {
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    minHeight: 40,
  },
  cellContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 8, // design spacing-8 top & bottom
    flex: 0, // Prevent vertical stretching
    overflow: "hidden",
    minHeight: 48,
    height: 48,
  },
  cellContainerAutoHeight: {
    height: 'auto' as any,
    alignItems: 'flex-start',
    paddingVertical: 10,
  },
  centerContent: {
    alignItems: "center",
    justifyContent: "center",
  },
  header: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#3A3A3A",
  },
  description: {
    fontSize: 14,
    color: "#616161",
    // marginBottom: Platform.OS === "web" ? 20 : 0,
  },
  headerRow: {
    flexDirection: "row",
    alignItems: "stretch",
    backgroundColor: "transparent",
    minHeight: 48,
    borderBottomWidth: 2,
    borderBottomColor: "#D7E5F8",
    width: "100%",
    zIndex: 1,
    overflow: 'visible', // Allow filter dropdowns to show
  },
  headerCellContainer: {
    overflow: 'visible', // Override overflow for header cells to show dropdowns
  },
  row: {
    flexDirection: "row",
    paddingVertical: 0, // padding moved to cell level to match design
    borderBottomWidth: 2,
    borderBottomColor: "#D7E5F8",
    width: "100%", // Take full width
    flex: 1,
    minHeight: 48,
    height: 48,
    alignItems: "center", // vertically center cell content
  },
  rowAutoHeight: {
    height: 'auto' as any,
    alignItems: 'stretch',
  },
  selectedRow: {
    backgroundColor: "#e0f7fa",
  },
  cellTouchable: {
    flex: 1,
    justifyContent: "flex-start",
    width: "100%", // Take full width
    paddingHorizontal: 4, // Add horizontal padding to give the text some breathing room
    paddingVertical: 0, // vertical padding handled by container
    // alignItems controlled dynamically based on platform
  },
  cell: {
    fontSize: Platform.OS === "web" ? 14 : 12,
    flexShrink: 1, // Allow text to shrink if needed
    width: "100%", // Take full width of container
    flexWrap: "wrap", // Enable text wrapping
    flexDirection: "row", // Needed for proper text wrapping
    textAlignVertical: "center", // vertical align middle for platforms that support it
    fontWeight: "400", // regular weight for cell text
    fontFamily: FontFamily.regular,
    // Left align only for web and iOS iPad, center for iOS mobile
  },
  headerCell: {
    fontWeight: "700",
    fontSize: Platform.OS === "web" ? 12 : 12, // XSmall equivalent
    textAlign: "center",
    flexWrap: "nowrap",
    lineHeight: 18,
    width: "100%",
    color: "#3A3A3A",
    backgroundColor: "transparent",
    zIndex: 2,
    textTransform: "uppercase", // design requires uppercase
    letterSpacing: 0,
  },
  headerCellText: {
    // keep the text to its content size so the icon sits right next to it
    fontWeight: "700",
    fontSize: 12,
    color: "#616161",
    textTransform: "uppercase",
    lineHeight: 18,
    includeFontPadding: false,
    padding: 0,
    flexShrink: 1,
    flexWrap: 'wrap',
    textAlign: "left",
    fontFamily: FontFamily.bold,
  },
  firstCellText: {
    color: "#005CBC",
    fontWeight: "500",
    fontFamily: FontFamily.regular,
  },
  otherCellText: {
    color: "#3A3A3A",
    fontFamily: FontFamily.regular,
  },
  typeCell: {
    color: "#FF6720",
    fontWeight: "bold",
    fontFamily: FontFamily.bold,
    // textDecorationLine: "underline",
  },
  // Overlay styles
  overlayContent: {
    padding: Platform.OS === "web" ? 16 : 12,
  },
  overlaySection: {
    marginBottom: Platform.OS === "web" ? 24 : 16,
    borderWidth: 1,
    borderColor: "#eaeaea",
    borderRadius: 8,
    overflow: "hidden",
  },
  overlaySectionTitle: {
    fontSize: Platform.OS === "web" ? 16 : 14,
    fontWeight: "bold",
    backgroundColor: "#0066CC",
    color: "#FFFFFF",
    padding: Platform.OS === "web" ? 12 : 10,
    fontFamily: FontFamily.regular,
  },
  overlaySummary: {
    padding: Platform.OS === "web" ? 16 : 12,
    flexDirection: "row",
    flexWrap: "wrap",
  },
  overlaySummaryMobile: {
    flexDirection: "column",
  },
  overlayField: {
    width: "50%",
    marginBottom: Platform.OS === "web" ? 12 : 8,
    paddingRight: Platform.OS === "web" ? 8 : 0,
  },
  overlayFieldMobile: {
    width: "100%",
    paddingRight: 0,
    marginBottom: 12,
  },
  overlayFieldLabel: {
    fontSize: Platform.OS === "web" ? 14 : 13,
    fontWeight: "bold",
    color: "#616161",
    marginBottom: 4,
    fontFamily: FontFamily.regular,
  },
  overlayFieldValue: {
    fontSize: Platform.OS === "web" ? 16 : 14,
    color: "#212121",
    fontFamily: FontFamily.regular,
  },
  overlayAdditionalContent: {
    padding: Platform.OS === "web" ? 16 : 12,
    fontSize: Platform.OS === "web" ? 15 : 14,
    lineHeight: Platform.OS === "web" ? 22 : 20,
    color: "#424242",
    fontFamily: FontFamily.regular,
  },
  noDataContainer: {
    padding: 20,
    alignItems: "center",
    justifyContent: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#d7e5f8",
  },
  noDataText: {
    color: "#616161",
    fontSize: 16,
    fontFamily: FontFamily.regular,
  },
  clearFiltersLink: {
    color: '#005CBC',
    fontSize: 14,
    fontFamily: FontFamily.medium,
    fontWeight: '600',
    textDecorationLine: 'underline',
  },
  // Pagination styles
  paginationContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 10,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: "#E0E0E0",
  },
  rowsPerPageContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    flexShrink: 1,
  },
  rowsPerPageLabel: {
    fontSize: 14,
    color: "#616161",
    fontWeight: "400",
    fontFamily: FontFamily.regular,
  },
  rowsPerPageSecondaryText: {
    fontSize: 14,
    color: "#616161",
    fontWeight: "700",
    fontFamily: FontFamily.bold,
    marginLeft: 10,
  },
  dropdownContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderWidth: 1,
    borderColor: "#D0D0D0",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    minWidth: 60,
    justifyContent: "space-between",
  },
  dropdownValue: {
    fontSize: 14,
    color: "#3A3A3A",
    fontWeight: "400",
    fontFamily: FontFamily.regular,
  },
  pageNavigationContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 0,
    flexShrink: 1,
  },
  navigationButton: {
    padding: 8,
    borderRadius: 4,
    backgroundColor: "transparent",
    borderWidth: 1,
    borderColor: "#D0D0D0",
    alignItems: "center",
    justifyContent: "center",
  },
  navigationButtonNoBorder: {
    padding: 8,
    borderRadius: 4,
    backgroundColor: "transparent",
    alignItems: "center",
    justifyContent: "center",
  },
  navigationButtonDisabled: {
    borderColor: "#F0F0F0",
    backgroundColor: "#F8F8F8",
  },
  pageIndicatorContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    flexShrink: 1,
  },
  currentPageBox: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderWidth: 1,
    borderColor: "#005CBC",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    alignItems: "center",
    justifyContent: "center",
  },
  currentPageText: {
    fontSize: 14,
    color: "#2D2D2D",
    fontWeight: "600",
    fontFamily: FontFamily.regular,
  },
  pageText: {
    fontSize: 14,
    color: "#2D2D2D",
    fontWeight: "400",
    fontFamily: FontFamily.regular,
  },
  pageOfText: {
    fontSize: 14,
    color: "#616161",
    fontWeight: "400",
    fontFamily: FontFamily.regular,
  },
  totalPagesText: {
    fontSize: 14,
    color: "#616161",
    fontWeight: "700",
    fontFamily: FontFamily.bold,
  },
  dropdownOptionsContainer: {
    position: "absolute",
    bottom: "100%",
    left: 0,
    right: 0,
    backgroundColor: "#FFFFFF",
    borderWidth: 1,
    borderColor: "#D0D0D0",
    borderRadius: 4,
    marginBottom: 6,
    zIndex: 1000,
  },
  dropdownOption: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#F0F0F0",
  },
  dropdownOptionSelected: {
    backgroundColor: "#F5F9FF",
  },
  dropdownOptionText: {
    fontSize: 14,
    color: "#3A3A3A",
    fontWeight: "400",
    fontFamily: FontFamily.regular,
  },
  dropdownOptionTextSelected: {
    color: "#005CBC",
    fontWeight: "600",
    fontFamily: FontFamily.regular,
  },
  // Mobile pagination styles (Figma-based)
  mobilePaginationContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 16,
    backgroundColor: "transparent", // Removed background color
  },
  mobilePaginationBox: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "transparent", // Removed background color
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "#D7E5F8",
    overflow: "hidden",
  },
  mobilePaginationCell: {
    minHeight: 32,
    minWidth: 32,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  mobilePaginationArrowCell: {
    backgroundColor: "transparent", // Removed background color
  },
  mobilePaginationCurrentCell: {
    backgroundColor: "#005CBC",
  },
  mobilePaginationNextCell: {
    backgroundColor: "#FBFCFE",
  },
  mobilePaginationCellDisabled: {
    opacity: 0.5,
  },
  mobilePaginationCurrentText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#FFFFFF",
    textAlign: "center",
    fontFamily: FontFamily.regular,
  },
  mobilePaginationNextText: {
    fontSize: 14,
    fontWeight: "400",
    color: "#005CBC",
    textAlign: "center",
    fontFamily: FontFamily.regular,
  },
  // Header cell content container
  headerCellContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    gap: 12,
  },
  // Sort icon container
  sortIconContainer: {
    alignItems: "center",
    justifyContent: "center",
  },
  // Sort icon styling
  sortIcon: {
    alignSelf: "center",
  },
  // Filter styles
  headerTooltip: {
    position: 'absolute',
    top: '100%' as any,
    left: 0,
    marginTop: -18,
    backgroundColor: '#2D2D2D',
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 5,
    zIndex: 9999,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 8,
    maxWidth: 320,
  },
  headerTooltipText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontFamily: FontFamily.regular,
    lineHeight: 16,
    flexShrink: 1,
  },
  filterDropdown: {
    position: 'absolute',
    top: '100%',
    right: 0, // Align to the right edge of the column (near filter icon)
    left: 'auto', // Override left positioning
    marginTop: 8,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#D0D0D0',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 20,
    width: 280,
    maxHeight: 400,
    zIndex: 999999,
  },
  filterDropdownHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  filterDropdownTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#2D2D2D',
    fontFamily: FontFamily.medium,
  },
  filterCloseButton: {
    padding: 4,
  },
  filterSearchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
    gap: 8,
  },
  filterSearchPlaceholder: {
    fontSize: 14,
    color: '#999999',
    fontFamily: FontFamily.regular,
  },
  filterOptionsContainer: {
    maxHeight: 250,
    paddingVertical: 8,
  },
  filterOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 10,
    gap: 10,
  },
  filterOptionText: {
    fontSize: 14,
    color: '#2D2D2D',
    fontFamily: FontFamily.regular,
    flex: 1,
  },
  filterFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: '#E0E0E0',
  },
  filterClearButton: {
    paddingVertical: 6,
    paddingHorizontal: 12,
  },
  filterClearButtonText: {
    fontSize: 14,
    color: '#005CBC',
    fontWeight: '600',
    fontFamily: FontFamily.medium,
  },
  filterValueCount: {
    fontSize: 12,
    color: '#999999',
    fontFamily: FontFamily.regular,
  },
  // ── Mobile card layout (iPhone only) ──────────────────────────────────────
  mobileCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#D7E5F8',
    paddingHorizontal: 14,
    paddingVertical: 12,
    marginHorizontal: 0,
  },
  mobileCardPrimary: {
    fontSize: 14,
    fontWeight: '600',
    color: '#005CBC',
    fontFamily: FontFamily.medium,
    marginBottom: 10,
    lineHeight: 20,
  },
  mobileCardRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingVertical: 4,
    gap: 8,
  },
  mobileCardLabel: {
    fontSize: 11,
    fontWeight: '700',
    color: '#616161',
    fontFamily: FontFamily.bold,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    width: 110,
    flexShrink: 0,
    paddingTop: 2,
  },
  mobileCardValue: {
    flex: 1,
    fontSize: 13,
    color: '#2D2D2D',
    fontFamily: FontFamily.regular,
    lineHeight: 18,
    flexWrap: 'wrap',
  } as any,
  mobileCardSeparator: {
    height: 8,
    backgroundColor: 'transparent',
  },
});
